import ENV from "../env";

const getRevenueSummaryByDate = async (orgIds, start, end, options = {}) => {
  const params = new URLSearchParams({ cacheBust: Date.now() });
  if (options.paymentMethod !== undefined) params.set("paymentMethod", options.paymentMethod || "all");
  if (options.includeOrganizations) params.set("includeOrganizations", "true");
  const response = await fetch(
    `${ENV.firebaseApiUrl}/organization/revenue-summary-by-date/${orgIds}/${start.toString()}/${end.toString()}?${params}`,
    {
      method: "GET",
      signal: options.signal,
      cache: "no-store",
      headers: { "Content-Type": "application/json" },
    },
  );

  const responseBody = await response.text();
  let resData;
  try {
    resData = responseBody ? JSON.parse(responseBody) : null;
  } catch {
    resData = null;
  }

  if (!response.ok) {
    throw new Error(resData?.message || responseBody || "Failed to fetch revenue summary");
  }

  return resData;
};

export default getRevenueSummaryByDate;
